const NullLoader = () => null;

export default NullLoader;
